import { TFunction } from 'i18next';
import {
  AssetClass,
  GroupType,
  OptionalAssets,
  Program,
} from '@monorepo/types';

/**
 * Get asset display name
 */
export const getAssetDisplayName = (
  asset: OptionalAssets,
  t: TFunction<['purchase']>,
): string => {
  switch (asset) {
    case OptionalAssets.Forex:
      return t('purchase:trading_system.assets.forex.title');
    case OptionalAssets.Futures:
      return t('purchase:trading_system.assets.futures.title');
    case OptionalAssets.DayTrade:
      return t('purchase:trading_system.assets.day.title');
    case OptionalAssets.Swing:
      return t('purchase:trading_system.assets.swing.title');
    case OptionalAssets.QuickBuy:
      return t('purchase:trading_system.assets.quick-buy.title');
    default:
      return t('purchase:trading_system.assets.forex.title');
  }
};

export const getAssetDisplayNameFromAssetClass = (
  assetClass: AssetClass,
  t: TFunction<['purchase']>,
): string => {
  switch (assetClass) {
    case AssetClass.Forex:
      return t('purchase:asset_class.forex');
    case AssetClass.Futures:
      return t('purchase:asset_class.futures');
    case AssetClass.Stocks:
      return t('purchase:asset_class.stocks');
    default:
      return t('purchase:asset_class.forex');
  }
};

export const getAssetFromProducts = (
  products: { programs: Program[]; groups: GroupType[] },
  productId: string,
): OptionalAssets | undefined => {
  const program = products.programs.find((p) => p._id === productId);
  if (!program) {
    return undefined;
  }

  const group = products.groups.find((g) => g.name === program.groupName);
  if (!group) {
    return undefined;
  }

  return group.asset;
};
